<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <TransitionRoot as="template" :show="open">
        <Dialog as="div" static class="fixed z-10 inset-0 overflow-y-auto">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                    <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </TransitionChild>
                <!-- This element is to trick the browser into centering the modal contents. -->
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                    <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                            <div class="sm:flex sm:items-start">
                                <div :class="backgroundClasses" class="mx-auto shrink-0 flex items-center justify-center h-12 w-12 rounded-full sm:mx-0 sm:h-10 sm:w-10">
                                    <CheckCircleIcon v-if="type == 'success'" :class="textClasses" class="h-6 w-6" aria-hidden="true" />
                                    <InformationCircleIcon v-else-if="type == 'info'" :class="textClasses" class="h-6 w-6" aria-hidden="true" />
                                    <ExclamationIcon v-else-if="type == 'warning'" :class="textClasses" class="h-6 w-6" aria-hidden="true" />
                                    <XCircleIcon v-else-if="type == 'danger'" :class="textClasses" class="h-6 w-6" aria-hidden="true" />
                                </div>
                                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                    <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">
                                        {{ title }}
                                    </DialogTitle>
                                    <div class="mt-2">
                                        <p class="text-sm text-gray-500" v-html="message"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                            <button type="button" :class="buttonClasses" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm" @click="performAction()">
                                {{ actionName }}
                            </button>
                            <button type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm" @click="open = false" ref="cancelButtonRef">
                                Cancel
                            </button>
                        </div>
                    </div>
                </TransitionChild>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<script>
import Bus from '../_core/bus'
import { usePage } from '@inertiajs/inertia-vue3'
import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { CheckCircleIcon, InformationCircleIcon, ExclamationIcon, XCircleIcon } from '@heroicons/vue/outline'

import { ref } from 'vue'

export default {

    components: {
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        CheckCircleIcon,
        InformationCircleIcon,
        ExclamationIcon,
        XCircleIcon,
    },

    setup() {
        const open = ref(false)

        return {
            open,
        }
    },

    data() {
        return {
            type: '',
            title: '',
            message: '',
            actionName: '',
            namedRoute: '',
            method: '',
            model: {}
        }
    },

    mounted() {

        Bus.$on('openAlertModal', data => {
            Object.assign(this.$data, data)

            this.open = true
        })

    },

    methods: {

        performAction() {

            let url = this.route(this.namedRoute, this.model)
            let data = {}

            this.model._method = this.method

            this.$inertia.post(url, this.model)

            this.open = false

        }

    },

    computed: {

        backgroundClasses() {

            if (this.type == 'success') {
                return 'bg-green-100'
            }

            if (this.type == 'info') {
                return 'bg-blue-100'
            }

            if (this.type == 'warning') {
                return 'bg-yellow-100'
            }

            if (this.type == 'danger') {
                return 'bg-red-100'
            }

        },

        textClasses() {

            if (this.type == 'success') {
                return 'text-green-600'
            }

            if (this.type == 'info') {
                return 'text-blue-600'
            }

            if (this.type == 'warning') {
                return 'text-yellow-600'
            }

            if (this.type == 'danger') {
                return 'text-red-600'
            }

        },

        buttonClasses() {

            if (this.type == 'success') {
                return 'bg-green-600 hover:bg-green-700 focus:ring-green-500'
            }

            if (this.type == 'info') {
                return 'bg-blue-600 hover:bg-blue-700 focus:ring-blue-500'
            }

            if (this.type == 'warning') {
                return 'bg-yellow-600 hover:bg-yellow-700 focus:ring-yellow-500'
            }

            if (this.type == 'danger') {
                return 'bg-red-600 hover:bg-red-700 focus:ring-red-500'
            }

        }

    }
}

</script>
